import { render, staticRenderFns } from "./ViewRequestModal.vue?vue&type=template&id=b840e470&"
import script from "./ViewRequestModal.vue?vue&type=script&lang=js&"
export * from "./ViewRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewRequestModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports